import React from 'react';
import {
	Header,
	Icon,
	List,
	Popup
} from 'semantic-ui-react';

const EmailValidationInfoPopup = () => {
	return (
		<Popup
			position="top center"
			trigger={
				<Icon
					name="info circle"
					size="large"
				/>
			}
			wide="very"
		>
			<Popup.Content>
				<Header as="h4">
					To be valid, an email address must adhere to the following:
				</Header>
				<List bulleted>
					<List.Item>Must consist of a local part and a host domain separated by the &ldquo;@&rdquo; character.</List.Item>
					<List.Item>May not exceed 254 characters in length.</List.Item>
					<List.Item>The local part may not exceed 64 characters in length.</List.Item>
					<List.Item>No part of the host domain may exceed 63 characters in length.</List.Item>
					<List.Item>The local part must consist of at least one letter (a-z), digit (0-9), or special character (&nbsp;`&nbsp;~&nbsp;!&nbsp;#&nbsp;$&nbsp;%&nbsp;^&nbsp;&&nbsp;*&nbsp;-&nbsp;_&nbsp;=&nbsp;+&nbsp;{ }&nbsp;|&nbsp;&apos;&nbsp;/&nbsp;?&nbsp;).</List.Item>
					<List.Item>A &ldquo;.&rdquo; may also be used, provided it is not the first or last character and that two or more do not appear consecutively.</List.Item>
					<List.Item>The host domain must consist of one or more second-level domain names followed by a top-level domain name.</List.Item>
					<List.Item>All domain names must be separated by a &ldquo;.&rdquo;.</List.Item>
					<List.Item>Second-level domain names may consist of letters (a-z), digits (0-9), and the &ldquo;-&rdquo; character, provided it is not the first or last character.</List.Item>
					<List.Item>The top-level domain name must be at least two characters in length and begin with a letter (a-z).</List.Item>
				</List>
			</Popup.Content>
		</Popup>
	);
};

export default EmailValidationInfoPopup;
